<template>
  <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
    <table class="min-w-full divide-y divide-gray-200">
      <thead class="bg-gray-50">
        <tr>
          <th v-if="isCheckbox" class="w-0 px-4">
            <slot name="header-checkbox"></slot>
          </th>
          <th
            v-for="header in headers"
            :key="header.value"
            class="px-4 py-2"
            :class="header.class"
          >
            <span
              v-if="header.sortable === false"
              class="
                text-base
                font-medium
                text-gray-600
                cursor-default
                select-none
              "
              >{{ header.text }}</span
            >
            <button
              v-else
              type="button"
              class="group inline-flex items-center focus:outline-none"
              @click="$emit('sort', header.value)"
            >
              <span class="text-base font-medium text-gray-600">
                {{ header.text }}
              </span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5 text-gray-600 transition duration-150"
                :class="[
                  options.sortBy !== header.value
                    ? 'opacity-25 group-hover:opacity-100'
                    : '',
                  options.sortBy === header.value && options.sortDesc
                    ? 'transform rotate-180'
                    : '',
                ]"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>
          </th>
          <th v-if="isNext"></th>
        </tr>
      </thead>
      <tbody class="bg-white divide-y divide-gray-200 relative">
        <tr v-if="!loading && items.length === 0">
          <td :colspan="headers.length + 1" class="text-center px-4 py-4">
            NO DATA HERE!
          </td>
        </tr>
        <tr v-if="loading">
          <td
            v-if="items.length === 0"
            :colspan="headers.length + 1"
            class="text-center px-4 py-4"
          >
            Loading...
          </td>
          <div v-else class="absolute inset-0 bg-white opacity-70">
            <p
              class="
                h-full
                w-full
                flex
                items-center
                justify-center
                text-base
                font-medium
                text-gray-900
              "
            >
              Loading...
            </p>
          </div>
        </tr>
        <tr
          @click="$emit('rowClick', item)"
          class="group"
          :class="handleRowClass(item)"
          v-for="(item, i) in items"
          :key="i"
        >
          <td v-if="isCheckbox" class="w-0 px-4">
            <slot name="body-checkbox" v-bind:item="item"></slot>
          </td>
          <td
            v-for="header in headers"
            :key="header.value"
            class="px-4 py-2 text-gray-800"
            :class="header.class"
          >
            <slot :name="header.value" v-bind:item="item">
              {{
                item[header.value.split('.')[0]] !== null
                  ? header.value.split('.').reduce((o, i) => o[i], item)
                  : ''
              }}
            </slot>
          </td>
          <td v-if="isNext" class="w-6 opacity-0 group-hover:opacity-100">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 text-gray-400"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <slot name="tfoot"></slot>
      </tfoot>
    </table>
  </div>
</template>

<script>
export default {
  name: 'AppDataTable',

  props: {
    headers: {
      type: Array,
      required: true,
    },

    options: {
      type: Object,
      required: true,
    },

    items: {
      type: Array,
      required: true,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    isCheckbox: {
      type: Boolean,
      default: false,
    },

    isNext: {
      type: Boolean,
      default: false,
    },

    rowClassFunction: {
      type: Function,
      default: () => {},
    },
  },

  methods: {
    handleRowClass(item) {
      return this.rowClassFunction(item)
    },
  },
}
</script>
